<template>
    <section class="view fix-space__button" v-if="hasPermissions(['Daily-Assignment Read'])">
        <DetailComponentDailyAssignment
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :rest_api_lite="rest_api_lite"
            :parent_id="parent_id"
            :rest_api_note="rest_api_note"
            :title_page="title_page"
            :single_object="single_object"
            :array_options="array_options"
            :form_format="form_format"
            :notes="single_object.notes_entities"
            :back_href="'/assignment-daily-assignments'"
            :child_href="'/assignment-daily-assignments'"
            :map="false"
            :historiable="true"
            @AssignmentNote="form_modal_note()"
            :duty_note="duty_note"
            comment_under_title="Make any changes and click Save"
            :daily_assignments_collection="daily_assignments_collection"
            @saveOutside="afterSaved()"
            ref="detail_daily_assignment_component"
        >
        <template v-slot:under-form-component>
            <button  class="modal__buttons__item w-auto px-3" v-html="'See attached images'" type="button" @click="open_images_modal()"/>
        </template>
        </DetailComponentDailyAssignment>
        <AssignmentRoomImagesModal 
            :breadcrumb="breadcrumb"
            :single_object="single_object"
            :index_active="index_active"
            @removeRoomImage="removeRoomImage($event)"
            @nextImage="nextImage($event)"
            @previousImage="previousImage($event)"
        />

        <div class="row mb-0 assignments">

            <div class="col my-3">
                <hr/>
            </div>
            <div class="col-12 duties pt-0">
                <div class="row mb-0" v-if="notes.length">
                    <div class="col-12 pt-1">
                        <h1 class="view__title title--1 mt-0" v-html="'Assignment Notes'"/>
                    </div>
                    <div class="row detail__content__notes" style="max-height:250px;" v-if="notes.length">
                    <div class="col-lg-3" v-for="(note, i) in notes" :key="i">
                        <div class="row mb-0 no-gutters h-100">
                            <div class="col-12 card cardList hoverable">
                                <div class="card-content h-100">
                                    <div class="card-title">
                                        <div class="row mb-0 no-gutters">
                                            <div class="col-10">
                                                <a class="textTitleCard" v-html="`${note.title} <span style='font-size: 13px; font-weight: normal;'> / ${note.created_at}</span>`"/>
                                            </div>
                                            <div class="col-2 text-right">
                                                <a @click="note_modal_deletion(i)">
                                                    <i class="material-icons prefix" >
                                                        <img class="iconCard" src="/assets/img/trash.png" alt="date" style="right: 0rem; top: -6px; width: 24px; height: auto;" />
                                                    </i>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="row mb-0 no-gutters">
                                            <div class="col-12">
                                                <p class="mt-3 card-content__text" v-html="note.body_text" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    
                </div>

                <div class="row mb-0">
                    <div class="col-12 pt-1">
                        <h1 class="view__title title--1 mt-0" v-html="'Assignment Duties'" style="display: inline;"/>
                    </div>
                </div>

                <div class="assignment__bar-container">
                    
                    <div class="assignment__bar-container__first-group">
                        <button v-if="hasPermissions(['Daily-Assignment Move-Rooms', 'Daily-Assignment Move-Rooms-For-Day'])" class="modal__buttons__item w-auto px-3 mr-1 mb-1 ml-0" :class="{'disabled button__disabled' : !selected}" v-html="`Move`" :disabled="!selected" @click="move_rooms()"/>
                        <button v-if="hasPermissions(['Daily-Assignment Copy-Rooms'])" class="modal__buttons__item w-auto px-3 mr-1 mb-1 ml-0" :class="{'disabled button__disabled' : !selected}" v-html="`Copy`" :disabled="!selected" @click="move_rooms(true)"/>
                    </div>
                    <div class="assignment__bar-container__second-group">
                        <button class="modal__buttons__item w-auto px-3 mr-1 mb-1 ml-0" :class="{'disabled button__disabled' : !selected}" v-html="`Modify selected`" :disabled="!selected" @click="scheduleModal()"/>
                        <button v-if="hasPermissions(['Daily-Assignment Delete-Rooms'])" class="modal__buttons__item w-auto px-3 mr-1 mb-1 ml-0" :class="{'disabled button__disabled' : !selected}" v-html="`Delete selected`" :disabled="!selected" @click="massDelete()"/>
                    </div>
                    <div class="assignment__bar-container__third-group">
                        <a :href="`/assignment-daily-assignments-time-details/${( single_object.id) ? single_object.id : ''}`" class="modal__buttons__item w-auto px-3 mb-1 mr-1 ml-0" v-html="`Quick reports`"/>
                        <button class="modal__buttons__item w-auto px-3 mb-1 mr-1 ml-0" v-html="`Refresh`" @click="reloaded()"/>
                        <button class="modal__buttons__item w-auto px-3 mb-1 mr-1 ml-0" v-html="`Save grid`" @click="save_grid()"/>
                        <a v-if="hasPermissions(['Daily-Assignment Add-Rooms'])" :href="`/assignment-daily-assignments-rooms/${parent_id}`" class="modal__buttons__item w-auto px-3 mb-1 mr-1 ml-0">
                            Select rooms to add <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>
                        </a>
                        <a v-if="hasPermissions(['Assignment-Daily-Complete Read'])" :href="`/assignment-daily-assignment-complete/${parent_id}`" class="modal__buttons__item w-auto px-3 mb-1 mr-1 ml-0">
                            Complete assignment
                        </a>
                    </div>
                    <div class="assignment__bar-container__fourth-group">
                        <UploadOptions
                            v-if="hasPermissions(['Daily-Assignment Upload-Rooms'])"
                            :ref="'file_excel'"
                            :empty_format_data="empty_assignment_rooms_format_data"
                            :excel_file_headers="excel_file_headers"
                            :file_name="'assigments_rooms_template_file'"
                            @data="upload($event)"
                            class="mb-1 mr-1 ml-0"
                        />
                        <UploadOptions
                            :ref="'file_notes_excel'"
                            id="file_notes_excel"
                            :btn_label="'Notes Upload options'"
                            :empty_format_data="empty_format_data_notes"
                            :excel_file_headers="excel_file_headers_notes"
                            :file_name="'assigments_notes_template_file'"
                            @data="uploadNotes($event)"
                            class="mb-1 mr-1 ml-0"
                        />
                    </div>
                </div>
                <div class="row mb-0">
                    <div class="col-md-6 col-sm-12">
                        <div class="row">
                            <div class="formdynamic__item py-0 col-md-2 " style="margin-top: 20px;">
                                <div class="formdynamic__item__field">
                                    <label for="Room" class="modal-label active">Room</label>
                                    <input placeholder="" step="" maxlength="45" min="" max="45" type="text" v-on:input="debounceInput({value: $event.target.value, field:'room'})">
                                </div>
                            </div>
                            <div class="formdynamic__item py-0 col-md-2 mx-0" style="margin-top: 20px;">
                                <div class="formdynamic__item__field">
                                    <label for="Task" class="modal-label active">Task</label>
                                    <input placeholder="" step="" maxlength="45" min="" max="45" type="text" v-on:input="debounceInput({value: $event.target.value, field:'task'})">
                                </div>
                            </div>
                            <div class="formdynamic__item py-0 col-md-2 mx-0" style="margin-top: 20px;">
                                <div class="formdynamic__item__field">
                                    <label for="Task" class="modal-label active">Closed?</label>
                                    <select size="" class="input-field custom-select" v-model="form_data_search.closed">
                                        <option value="">Select All</option>
                                        <option value="1">Yes</option>
                                        <option value="0">No</option>
                                    </select>
                                </div>
                            </div>
                            <div class="formdynamic__item py-0 col-md-3 mx-0" style="margin-top: 20px;">
                                <div class="formdynamic__item__field">
                                    <label for="Task" class="modal-label active">Essential Cleaning</label>
                                    <select size="" class="input-field custom-select" v-model="form_data_search.essential_cleaning">
                                        <option value="">Select All</option>
                                        <option value="1">Yes</option>
                                        <option value="0">No</option>
                                    </select>
                                </div>
                            </div>
                            <div class="formdynamic__item py-0 col-md-3 mx-0" style="margin-top: 20px;">
                                <div class="formdynamic__item__field">
                                    <label for="Task" class="modal-label active">Show rooms that are</label>
                                    <select size="" class="input-field custom-select" v-model="form_data_search.show_rooms_that_are">
                                        <option value="">Select an option</option>
                                        <option value="1">Underassigned</option>
                                        <option value="2">Overassigned</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 col-sm-12">
                        <div class="templates__legend d-md-flex justify-content-md-between">
                            <div class="mb-2 mb-md-0 templates__legend__item" v-html="'Over assigned'"/>
                            <div class="mb-2 mb-md-0 templates__legend__item" v-html="'Under assigned'"/>
                            <div class="templates__legend__item" v-html="'For Today Only'"/>
                            <div class="templates__legend__item" v-html="'Closed'"/>
                        </div>
                        <span class="button__modal text-right">
                            <a class="d-inline-md-block" @click="showDutyNoteModal()">
                                Add Duty Note
                                <i class="prefix ml-1">
                                    <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                                </i>
                            </a>
                        </span>
                    </div>
                    <div class="col-md-12" v-if="rooms_assigned.length && !loader_search">
                        <div class="alert alert-primary" role="alert" v-if="rooms_assigned_for_today">
                            <i class="fa fa-info-circle mr-3" style="font-size: 15px;"/><b> {{rooms_assigned_for_today}}</b> room{{ rooms_assigned_for_today > 1 ? 's' : '' }} have been moved to this daily assignment for today only
                        </div>
                        <div class="table-responsive">
                            <table class="table"> 
                                <thead>
                                    <tr>
                                        <th scope="col" style="border-bottom: none">
                                            <span class="custom-control custom-checkbox">
                                                <input :id="'theadcheck'" v-model="select_all" type="checkbox" class="custom-control-input" @change="selectAllBoxes()"/>
                                                <label :for="'theadcheck'" class="custom-control-label ml-2"/>
                                            </span>
                                        </th>
                                        <th style="border-bottom: none" scope="col" v-for="(item, i) in room_table_headers" :key="i" v-html="item.name"/>
                                    </tr>
                                </thead>

                                <draggable v-if="!isTouchDevice() && !draggable_reset" v-model="rooms_assigned" tag="tbody" :multi-drag="true" multiDragKey="SHIFT" selectedClass="sortable-selected" :avoidImplicitDeselect="true" @start="drag=true" @end="drag=false" @change="orderRequest()" ghost-class="drag-ghost" :scroll-sensitivity="1000" 
                                        :force-fallback="true"
                                        >
                                    <!-- <transition-group type="transition" name="flip-list" tag="tbody"> -->
                                        <tr v-for="(item, i) in rooms_assigned" :key="i" :id="`room${i}`" :style="(item.room_id == from_room) ? style_from_room : ''"
                                            :class="[
                                                (item.closed) ? 'background-color-blue' : '',
                                                (frequencies[`${item.room_id}${item.task_id}`].total_frequency > item.frequency_manual ) && item.room_id &&  !item.project ? 'background-color-green-overassigned' : '',
                                                (frequencies[`${item.room_id}${item.task_id}`].total_frequency < item.frequency_manual) && !item.project &&  item.room_id ? 'background-color-orange-underassigned': '',
                                                (item.only_for_today) ? 'background-color-yellow-for-today' : '']"
                                        >
                                            <!-- <td style="display: hidden;"></td> -->
                                            <td>
                                                <span class="custom-control custom-checkbox">
                                                    <input :id="`checkAll${i}`" type="checkbox" class="custom-control-input" v-model="item.checked"/>
                                                    <label :for="`checkAll${i}`" class="custom-control-label ml-2"/>
                                                </span>
                                                <img src="../../../../public/assets/img/svg/hamburger.svg"/>
                                            </td>
                                            <td>
                                                <input :id="`idinput-${item.id}`" :value="item.order" @keyup.enter="reorderByInput(item, $event.target.value)" type="number" class="order-input" required/>
                                            </td>
                                            <td>
                                            {{  item.start_time }}
                                            </td>
                                            <td @click="item && item.room_id ? roomDetailSearch(i) : showDutyNoteModal(item, i)" class="prevent-select">
                                                <a v-if="item.room_id" style="color: #039be5; text-decoration: none; cursor:pointer;">
                                                    {{ item.room }} 
                                                    <b v-if="item.is_policing" style="font-style: oblique; color: #000000;"> - policing</b>
                                                </a>
                                                <a v-else style="text-decoration: none;">
                                                    {{ item.room }}
                                                </a>
                                                
                                            </td>
                                            <td class="prevent-select" v-html="item.task"/>
                                            <td>
                                                <span class="custom-control custom-checkbox">
                                                    <input :id="`sun${i}`" type="checkbox" class="custom-control-input" v-model="item.sunday"/>
                                                    <label :for="`sun${i}`" class="custom-control-label ml-2"/>
                                                </span>
                                            </td>
                                            <td>
                                                <span class="custom-control custom-checkbox">
                                                    <input :id="`mon${i}`" type="checkbox" class="custom-control-input" v-model="item.monday"/>
                                                    <label :for="`mon${i}`" class="custom-control-label ml-2"/>
                                                </span>
                                            </td>
                                            <td>
                                                <span class="custom-control custom-checkbox">
                                                    <input :id="`tue${i}`" type="checkbox" class="custom-control-input" v-model="item.tuesday"/>
                                                    <label :for="`tue${i}`" class="custom-control-label ml-2"/>
                                                </span>
                                            </td>
                                            <td>
                                                <span class="custom-control custom-checkbox">
                                                    <input :id="`wed${i}`" type="checkbox" class="custom-control-input" v-model="item.wednesday"/>
                                                    <label :for="`wed${i}`" class="custom-control-label ml-2"/>
                                                </span>
                                            </td>
                                            <td>
                                                <span class="custom-control custom-checkbox">
                                                    <input :id="`thur${i}`" type="checkbox" class="custom-control-input" v-model="item.thursday"/>
                                                    <label :for="`thur${i}`" class="custom-control-label ml-2"/>
                                                </span>
                                            </td>
                                            <td>
                                                <span class="custom-control custom-checkbox">
                                                    <input :id="`fri${i}`" type="checkbox" class="custom-control-input" v-model="item.friday"/>
                                                    <label :for="`fri${i}`" class="custom-control-label ml-2"/>
                                                </span>
                                            </td>
                                            <td>
                                                <span class="custom-control custom-checkbox">
                                                    <input :id="`sat${i}`" type="checkbox" class="custom-control-input" v-model="item.saturday"/>
                                                    <label :for="`sat${i}`" class="custom-control-label ml-2"/>
                                                </span>
                                            </td>
                                            
                                            <td class="prevent-select">{{numberStringFormat(item.minutes, 1) }}</td>
                                            <td class="prevent-select" v-html="item.sq_ft"/>
                                        </tr>
                                    <!-- </transition-group> -->
                                </draggable>

                                <tbody v-else>
                                    <tr v-for="(item, i) in rooms_assigned" :key="i" :id="`room${i}`" :style="(item.room_id == from_room) ? style_from_room : (item.only_for_today) ? style_for_today_rooms : ''"
                                    :class="[
                                        (item.closed) ? 'background-color-blue' : '',
                                        (frequencies[`${item.room_id}${item.task_id}`].total_frequency > item.frequency_manual ) && item.room_id &&  !item.project ? 'background-color-green-overassigned' : '',
                                        (frequencies[`${item.room_id}${item.task_id}`].total_frequency < item.frequency_manual) && !item.project &&  item.room_id ? 'background-color-orange-underassigned': '',
                                        (item.only_for_today) ? 'background-color-yellow-for-today' : '']"
                                    >
                                        <td>
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`checkAll${i}`" type="checkbox" class="custom-control-input" v-model="item.checked"/>
                                                <label :for="`checkAll${i}`" class="custom-control-label ml-2"/>
                                            </span>
                                            <img src="../../../../public/assets/img/svg/hamburger.svg"/>
                                        </td>
                                        <!-- <td v-html="(i+1)"/> -->
                                        <td>
                                            <input :id="`idinput-${item.id}`" :value="item.order" @keyup.enter="reorderByInput(item, $event.target.value)" type="number" class="order-input" required/>
                                        </td>
                                        <td>
                                            {{  item.start_time }}
                                        </td>
                                        <td @click="item && item.room_id ? roomDetailSearch(i) : showDutyNoteModal(item, i)">
                                            <a v-if="item.room_id" style="color: #039be5; text-decoration: none; cursor:pointer;">
                                            {{ item.room }} <b v-if="item.is_policing" style="font-style: oblique; color: #000000;"> - policing</b>
                                            </a>
                                            <a v-else style="text-decoration: none;" :style="item.is_policing ? 'font-weight: bold; color: #039be5;' : ''">
                                                {{ item.room }}
                                            </a>
                                            
                                        </td>
                                        <td v-html="item.task"/>
                                        <td>
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`sun${i}`" type="checkbox" class="custom-control-input" v-model="item.sunday"/>
                                                <label :for="`sun${i}`" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`mon${i}`" type="checkbox" class="custom-control-input" v-model="item.monday"/>
                                                <label :for="`mon${i}`" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`tue${i}`" type="checkbox" class="custom-control-input" v-model="item.tuesday"/>
                                                <label :for="`tue${i}`" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`wed${i}`" type="checkbox" class="custom-control-input" v-model="item.wednesday"/>
                                                <label :for="`wed${i}`" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`thur${i}`" type="checkbox" class="custom-control-input" v-model="item.thursday"/>
                                                <label :for="`thur${i}`" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`fri${i}`" type="checkbox" class="custom-control-input" v-model="item.friday"/>
                                                <label :for="`fri${i}`" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`sat${i}`" type="checkbox" class="custom-control-input" v-model="item.saturday"/>
                                                <label :for="`sat${i}`" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                        
                                        <td>{{numberStringFormat(item.minutes, 1) }}</td>
                                        <td v-html="item.sq_ft"/>
                                    </tr>
                                </tbody>

                                <AssignmentRoomResults
                                    :current_day_number="current_day_number"
                                    :minutes_results="minutes_results"
                                    :square_results="square_results"
                                    :summed_daily_minutes="summed_daily_minutes"
                                    :all_total_minutes="all_total_minutes"
                                />

                            </table>
                        </div>
                    </div>
                    <div class="w-100 text-center" v-else-if="loader_search">
                        <div class="spinner-border mt-2" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>

                <ScheduleModal 
                    :title="title"
                    :breadcrumb="breadcrumb"
                    :week_table_headers="week_table_headers"
                    :week_form_data="week_form_data"
                    @saveNewSchedule="saveNewSchedule($event)"
                />

                <FormModalNote 
                    :title="'New Note'"
                    :breadcrumb="breadcrumb"
                    :rest_api="note_rest_api"
                    :notyf="notyf"
                    :daily_assignments_collection="daily_assignments_collection"
                    :array_options="[]"
                    @noteCreated="noteCreated($event)"
                />

                

                <FormModalMove 
                    :title="'Move Rooms'"
                    :breadcrumb="breadcrumb"
                    :rest_api="lite_rest_api2"
                    :notyf="notyf"
                    :array_options="array_options_move"
                    :rooms="rooms_at_move"
                    :parent_id="parent_id"
                    :total_minutes="total_minutes"
                    @move="move($event)"
                    :permission_move="permission_move"
                    :daily_assignments_collection="daily_assignments_collection"
                />

                <FormModalRoomDetail 
                    :title="'Assignment at a glance'"
                    :breadcrumb="breadcrumb"
                    :room="single_room_child"
                    :assignments="daily_assignments_childs"
                />

                <FormModalCopy 
                    :title="'Copy Rooms'"
                    :breadcrumb="breadcrumb"
                    :rest_api="lite_rest_api2"
                    :notyf="notyf"
                    :array_options="array_options_move"
                    :rooms="rooms_at_move"
                    :parent_id="parent_id"
                    :total_minutes="total_minutes"
                />
                
                <UploadSummary
                    :breadcrumb="breadcrumb"
                    :summary="summary"
                    :excel_file_headers="summary_headers"
                    :excel_data="excel_data"
                    :file_name="'assigments_rooms_falied_template_file'"
                    @close="reload()"
                />

                <DeletionModal 
                :id="'static-deletion-note'"
                :single_object="single_note" 
                :global_index="index_note" 
                @objectDeletion="modal_trash($event)"
                />

            </div>
        </div>
        <HelperModal :helps="helps" styles="right: 250px;"/>
        <DutyNote
            :parent="single_object"
            :notyf="notyf"
            :daily_assignments_collection="daily_assignments_collection"
            :array_options="[]"
            @reloaded="reloaded($event)"
            ref="duty_note"
            @updateDutyNote="updateDutyNote($event)"
            :count_assignments="count_assignments"
        />
        <ConfirmationDutyNote 
            :breadcrumb="breadcrumb"
            :title="'Confirmation of changes'"
            @updateDutyNote="updateDutyNote($event)"
            :count_assignments="count_assignments"
        />
    </section>
</template>

<script>

// import Breadcrumb       from  '@/components/BreadcrumbComponent/Breadcrumb.vue'
import FormResources            from    './form_resources'
import HelperModal              from    '@/components/HelperModal'
import Resources                from    './resources'
import DetailComponentDailyAssignment from '@/components/DetailComponent/DetailComponentDailyAssignment'
import DeletionModal          from '@/components/DeletionModal'
import AssignmentRoomResults    from    './AssignmentRoomResults'
import ScheduleModal            from    './ScheduleModal'
import Methods                  from    './Methods'
// import draggable                from    'vuedraggable'
import draggable from 'vuedraggable-multi'
import { Notyf }                from    'notyf';
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'; // for React and Vue
import _ from "underscore";
import FormModalNote            from    './FormModalNote'
import FormModalMove            from    './FormModalMove'
import FormModalRoomDetail      from    './FormModalRoomDetail'
import FormModalCopy            from    './FormModalCopy'
import DutyNote                 from    './DutyNote'
import UploadOptions            from    '@/components/UploadOptions'
import UploadSummary            from    '@/components/UploadSummary'
import ConfirmationDutyNote     from './ConfirmationDutyNote'
import AssignmentRoomImagesModal from './AssignmentRoomImagesModal'

const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: 'DailyAssignmentDetail',

    components: {
        // Breadcrumb,
        AssignmentRoomImagesModal,
        DetailComponentDailyAssignment,
        ScheduleModal,
        AssignmentRoomResults,
        draggable,
        FormModalNote,
        FormModalMove,
        FormModalCopy,
        DutyNote,
        UploadOptions,
        FormModalRoomDetail,
        UploadSummary,
        DeletionModal,
        ConfirmationDutyNote,
        HelperModal
    },
    
    data(){
        return{
            notyf,
            user:                           this.get_user(),
            parent_id:                      this.$route.params.id,
            title:                          'Modify room days',
            rest_api:                       `daily_assignments/${this.$route.params.id}`,
            room_api:                       `rooms`,
            lite_rest_api:                  `daily_assignments`,
            rest_api_lite:                  `/daily_assignments`,
            rest_api_note:                  `daily_assignment_notes`,
            rest_api_assignment_notes:      `assignment_duty_notes`,
            note_rest_api:                  `assignment_notyfs`,
            lite_rest_api2:                 `assignment_rooms`,
            form_format:                    FormResources.form_format,
            breadcrumb:                     Resources.breadcrumb,
            week_table_headers:             Resources.week_table_headers,
            title_page:                     '',
            single_object:                  {},
            array_options:                  {},
            form_data:                      FormResources.form_data,
            form_backup:                    {...FormResources.form_data},
            select_all:                     false,
            daily_assignments_collection:   [],

            /**** Options ************************************/
            room_table_headers: Resources.room_table_headers,
            boolean_options:    Resources.boolean_options,
            excl_options:       Resources.excl_options,
            freq_options:       Resources.freq_options,
            /*************************************************/

            rooms_assigned:     [],
            minutes_results:    [],
            square_results:     [],

            week_form_data:             FormResources.week_form_data,
            schedule_models:            Resources.schedule_models,
            schedule_models_backup:     {...Resources.schedule_models},
            frequencies:                {},
            array_options_move: {
                daily_assignment_id : []
            },
            rooms_at_move:               [],
            total_minutes:               0,
            summary_headers:                    null,
            excel_file_headers:                 Resources.excel_file_headers_rooms,
            empty_format_data:                  Resources.empty_format_data_rooms,
            empty_assignment_rooms_format_data: Resources.empty_assignment_rooms_format_data,
            excel_file_headers_notes:           Resources.excel_file_headers_notes,
            empty_format_data_notes:            Resources.empty_format_data_notes,
            excel_fields_required:              Resources.excel_fields_required_rooms,

            single_room_child: {},
            daily_assignments_childs: [],
            summary:                [],
            excel_data:             [],
            notes: [],
            single_note:            {},
            index_note:             null,
            from_room:              '',
            duty_note:              false,
            rooms_assigned_for_today: 0,
            style_from_room: 'border: solid; border-color: rgb(19, 42, 252);',
            permission_move: 0,
            count_assignments: 0,
            summed_daily_minutes: 0,
            current_day_number: '',
            all_total_minutes: 0,
            form_data_search: FormResources.form_data_search,
            loader_search: false,
            draggable_reset: false,
            helps:                  Resources.helps_detail_screen,
            index_active: 0
        }
    },

    mixins: [
        Methods,
    ],

    methods:{
        debounceInput:  _.debounce(function (e)  {
            this.form_data_search[e.field] = e.value
        },800),

        nextImage()
        {
            if(this.index_active < (this.single_object.assignment_room_images.length - 1))
            {
                this.index_active++
            }
            else
            {
                this.index_active = 0
            }
        },

        previousImage()
        {
            if(this.index_active > 0)
            {
                this.index_active--
            }
            else
            {
                this.index_active = this.single_object.assignment_room_images.length - 1
            }
        },

        open_images_modal()
        {
            this.getRoomImages()
            window.$('#static-assignment-room-images').modal('show')
        },

        afterSaved()
        {
            this.getRoomImages()
            this.single_object.new_assignment_room_images = []
        },

        async removeRoomImage({id, index})
        {
            window.$('#static-assignment-room-images').modal('hide')
            this.index_active = 0
            this.loader(true)
            const response = await this.get(`${this.lite_rest_api}/delete/room_images/${id}`)
            this.loader()
            window.$('#static-assignment-room-images').modal('show')

            if(response.status)
            {
                this.single_object.assignment_room_images.splice(index, 1)
            }
            else
            {
                this.error_handling(response)
            }
        },

        async search()
        {
            this.loader_search = true
            this.form_data_search['daily_assignment_id'] = this.parent_id

            const response = await this.post(`${this.lite_rest_api2}/search/rooms`, this.form_data_search)

            if(response.status)
            {
                let data = response.data
                this.rooms_assigned = data.rooms_assigned
            }
            else
            {
                this.error_handling(response)
            }
            this.loader_search = false
        },

        async roomDetailSearch(index)
        {
            this.loader(true)

            let room_id = this.rooms_assigned[index].room_id

            let json_request = {
                default_assignments: true,
                room_id,
            }

            const response = await this.get(`${this.room_api}/${JSON.stringify(json_request)}`);

            if(response.status)
            {
                this.single_room_child = response.data.room
                this.daily_assignments_childs = response.data.daily_asssignments
                this.loader()
                setTimeout(()=> {
                    window.$(`#static-room-assignments`).modal('show')
                }, 500)
            }
            else
            {
                this.error_handling(response)
                this.loader()
            }
        },

        form_modal_note()
        {
            window.$(`#static-assignment-note`).modal('show')
        },

        note_modal_deletion(index)
        {
            this.index_note = index
            this.single_note = {...this.notes[index]}
            window.$('#static-deletion-note').modal('show')
        },
    
        async modal_trash(object_destroyed)
        {
            this.loader(true)

            let json_request = {
                notyf_detach: true,
                daily_assignment_id: this.parent_id,
                assignment_notyf_id: object_destroyed.id,
            }

            const response = await this.delete(`${this.note_rest_api}/${JSON.stringify(json_request)}`)

            if(response.status)
            {
                this.index_note = null
                this.single_note = {}
                this.notes.splice(object_destroyed.index, 1)
                notyf.success('Deleted success!')
                window.$('#static-deletion-note').modal('hide')
                this.loader()
            } 
            else
            {
                this.error_handling(response)
                this.loader()
            }
        },

        async getRoomImages()
        {
            const response = await this.get(`${this.lite_rest_api}/get/room_images/${this.single_object.id}`)

            if(response.status)
            {
                this.single_object.assignment_room_images = response.data.data
            }
            else
            {
                this.error_handling(response)
            }
        },

        fill_data(data)
        {
            this.single_object  = {...data.daily_assignment, new_assignment_room_images: [], assignment_room_images: []};
            this.$refs.detail_daily_assignment_component.setJumpToValue(this.single_object.id)
            this.getRoomImages()
            this.daily_assignments_collection = data.daily_assignments;
            this.title_page = `${this.single_object.number_assigment} - ${this.single_object.description}`
            this.rooms_assigned = data.rooms_assigned
            this.notes = data.notes
            this.rooms_assigned_for_today = data.rooms_assigned_for_today
            this.summed_daily_minutes = data.summed_daily_minutes
            this.single_object.total_shift_work_time = this.numberStringFormat(Number(this.single_object.total_shift_work_time.replace(/,/g, '')) + Number(data.summed_minutes_available), 1)

            if(this.rooms_assigned.length)
            {
                this.rooms_assigned.forEach((item, index) => {
                    item['checked'] = false
                    item['order'] = index + 1 
                })
            }

            this.array_options = {
                associate_id:               data.associates,
                shift_id:                   data.shifts,
                group_id:                   data.groups,
                cost_center_id:             data.cost_centers,
                cost_center_department_id:  data.cost_center_departments,
                supervisor_associate_id:    data.supervisors,
                building_id:                data.buildings,
                area_id:                    [],
                floor_id:                   data.floors,
                task_id:                    data.tasks,
                room_type_id:               data.room_types,
                day_id:                     data.days,
                new_assignment_room_images: 'image/jpeg, image/png, image/jpg, image/webp'
            }

            const days = this.array_options.day_id.filter(day => this.single_object[day.id]).map(day => day.id);

            this.single_object['day_id'] = days

            const frequencies = this.rooms_assigned.map(item => ({ room_id: item.room_id, task_id: item.task_id, total_frequency: item.total_frequency}))

            const tasks = _.uniq(frequencies, item => [item.room_id, item.task_id].join());

            for (const task of tasks)
            {
                this.frequencies[`${task.room_id}${task.task_id}`] = {
                    total_frequency : task.total_frequency
                }
            }
        },
        async noteCreated()
        {
            const response = await this.get(`${this.note_rest_api}/${this.parent_id}`)
            if(response.status)
            {
                this.notes = response.data.notes
            }
            else
            {
                this.error_handling(response)
            }

        },

        showDutyNoteModal(form_data = null, i = -1)
        {
            setTimeout(() => { 
                this.$refs.duty_note.startModal(form_data, i);
                window.$('#static').modal('show')
            }, 100);

        },

        async updateDutyNote(event)
        {
            let form_data = this.$refs.duty_note.form_data
            form_data['edit_all'] = event.edit_all

            this.loader(true)
            const response = await this.put(`${this.rest_api_assignment_notes}/${form_data.id}`, form_data)
            if(response.status)
            {
                this.reloaded()
                notyf.success(`Updated success!`)
            }
            else
            {
                window.$('#static').modal('show')
                this.error_handling(response)
            }

            this.loader()

        },

        async updateOrd(data)
        {
            console.log([data, 'data'])
            // await this.postingByPost('post_dragging', data)
        },

        async upload(data)
        {
            this.excel_data = data

            this.loader(true)
            const response = await this.post(`${this.lite_rest_api2}/massive`, { room_tasks: this.excel_data, timestamp: this.getCurrentDateTime() })
            this.loader()

            if(response.status)
            {
                if(response.data.is_queue)
                {
                    notyf.success('Given you are uploading many records, you will get notified when the upload process is finished.')
                    return;
                }

                notyf.success('Success!')
                this.summary_headers = this.excel_file_headers
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')
            }
            else
            {
                this.error_handling(response)
            }

            this.reloaded()
            
            this.$refs.file_excel.clear_data()
        },

        async uploadNotes(data)
        {
            this.excel_data = data
            this.loader(true)
            const response = await this.post(`${this.rest_api_assignment_notes}/massive`, {notes: data, timestamp: this.getCurrentDateTime()})
            this.loader()

            if(response.status)
            {
                if(response.data.is_queue)
                {
                    notyf.success('Given you are uploading many records, you will get notified when the upload process is finished.')
                    return;
                }

                notyf.success('Success!')
                this.summary_headers = this.excel_file_headers_notes
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')
            }
            else
            {
                this.error_handling(response)
            }

            this.reloaded()
            
            this.$refs.file_notes_excel.clear_data()
        },

        reload() {
            setTimeout(() => {
                window.location.reload()
            }, 500)
        }

    },

    watch: {
        form_data_search:{
            handler()
            {
                this.search()
            }, 
            deep: true
        },

        async 'single_object.census'(val)
        {
            if(val)
            {
                this.form_format[13].required = true
                this.form_format[13]['minlength'] = 0
            }
            else
            {
                this.form_format[13].required = false
                this.form_format[13]['minlength'] = ''
            }
        },

        "single_object.days_per_week"(val)
        {
            if(val < 0 || val > 7){
                this.single_object.days_per_week = 0
            }
            else 
            {
                this.globalStatistics(this.rooms_assigned);
            }
        },

        rooms_assigned:{
            handler(val)
            {
                this.globalStatistics(val);
            },
            deep: true
        }
    },

    async mounted()
    {
        if(this.hasPermissions(['Daily-Assignment Read']))
        {
            await this.api_request(this.rest_api)
            await this.globalStatistics(this.rooms_assigned)


            this.breadcrumb[2].arrow = "<span class='slash'>/</span>"
            this.breadcrumb.push({
                name:   this.single_object.description,
                href:   '#',
                arrow:  " ",
            });

            if(this.$route.query.from_room)
            {
                this.from_room = this.$route.query.from_room
            }
        }
        else
        {
            window.location.href = "/"
        }
    }, 

    computed:
    {
        selected()
        {
            let bool = this.rooms_assigned.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }

}
</script>

<style scoped>
    .order-input
    {
        border-bottom: 1px solid #0000 !important;
    }
    .drag-ghost {
        border-bottom: 3px solid #008AD8;
    }
    .highlight-previous-room{
        border-color: rgb(19, 42, 252); border-top: solid; border-bottom: solid;
    }

    .custom-control-label::before
    {
        width: 1.25rem;
        height: 1.25rem;
    }

    .custom-control-label::after 
    {
        width: 1.25rem;
        height: 1.25rem;
    }

    /* .drag-ghost::after {
        opacity: 0;
    } */


</style>
